/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import ScrollerList from '@/components/ScrollerList';
import ScrollerItem from '@/components/ScrollerList/ScrollerItem';
import SearchBar from '@/components/SearchBar';
import { getKnowledgeDocList, getDocTypeList } from '@/api';
import SmyDatetimeRange from '@/components/SmyDatetimeRange';
import CheckUser from '@/components/CheckUser';
export default {
  name: 'DOC',
  props: {
    id: {
      type: [String, Number],
      default: ''
    }
  },
  components: {
    Cell: Cell,
    Group: Group,
    SmyDatetimeRange: SmyDatetimeRange,
    ScrollerList: ScrollerList,
    ScrollerItem: ScrollerItem,
    SearchBar: SearchBar,
    CheckUser: CheckUser
  },
  data: function data() {
    return {
      serviceTypeList: [],
      parentList: [],
      parentId: '',
      params: {
        pageIndex: 0,
        pageSize: 10,
        keyword: '',
        categary_id: -1
        // start_time: '',
        // end_time: '',
        // user_id: '',
        // user_name: '请选择'
      },
      count: 0,
      typeName: -1,
      typeList: [],
      list: [],
      checkUserModal: false
    };
  },
  watch: {
    parentId: function parentId(val) {
      this.loadType(val);
      this.params.categary_id = val;
      this.onPulldownLoading(true);
    }
  },
  computed: {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      // eslint-disable-next-line
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 4 * fontSize;
    },
    hasMore: function hasMore() {
      return this.list.length < this.count;
    }
  },
  methods: {
    initProp: function initProp() {
      var _this = this;
      if (this.id) {
        this.id.split(',').forEach(function (item, index) {
          if (+item !== 0) {
            _this.changeParent(index, item);
          }
        });
      }
    },
    loadType: function loadType(parentId) {
      var _this2 = this;
      getDocTypeList({
        parentId: parentId
      }).then(function (res) {
        if (res.success) {
          _this2.serviceTypeList = res.data.map(function (v) {
            return Object.assign(v, {
              parentId: v.fk_t_parent_id
            });
          });
        }
      });
    },
    toggleParent: function toggleParent(id, parentId, v) {
      this.parentList.push(v);
      this.parentId = id;
    },
    changeParent: function changeParent(index, id) {
      this.parentList = this.parentList.slice(0, index + 1);
      this.parentId = id;
    },
    onPulldownLoading: function onPulldownLoading() {
      var _this3 = this;
      this.params.pageIndex = 0;
      getKnowledgeDocList(this.params).then(function (res) {
        if (res.success) {
          _this3.count = res.data.count;
          _this3.list = res.data.list;
        }
        _this3.$refs['orderList'] && _this3.$refs['orderList'].enablePullup();
        if (_this3.hasMore) {
          _this3.$refs['orderList'] && _this3.$refs['orderList'].donePullup();
        } else {
          _this3.$refs['orderList'] && _this3.$refs['orderList'].disablePullup();
        }
        _this3.$refs['orderList'] && _this3.$refs['orderList'].donePulldown();
      });
    },
    onPullupLoading: function onPullupLoading() {
      var _this4 = this;
      this.params.pageIndex++;
      getKnowledgeDocList(this.params).then(function (res) {
        if (res.success) {
          _this4.count = res.data.count;
          _this4.list = _this4.list.concat(res.data.list);
        }
        if (_this4.hasMore) {
          _this4.$refs['orderList'] && _this4.$refs['orderList'].donePullup();
        } else {
          _this4.$refs['orderList'] && _this4.$refs['orderList'].disablePullup();
        }
      });
    },
    refresh: function refresh() {
      this.onPulldownLoading();
    },
    reset: function reset() {
      this.params = {
        pageIndex: 0,
        pageSize: 10,
        keyword: '',
        categary_id: -1
        // start_time: '',
        // end_time: '',
        // user_id: '',
        // user_name: '请选择'
      };
    }
  },
  created: function created() {
    this.initProp();
    this.loadType(0);
    // 获取FAQ分类
    // getKnowledgeDocTypeList({}).then(res => {
    //   if (res.success) {
    //     this.typeList = []
    //     this.typeList.push({ name: '全部文档', value: -1 })
    //     res.data.forEach((item, index) => {
    //       this.typeList.push({ name: item.name, value: item.id })
    //     })
    //   }
    // })
    this.refresh();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.checkUserModal) {
      this.checkUserModal = !this.checkUserModal;
    } else {
      next();
    }
  }
};